module.exports = __webpack_public_path__ + "img/within-feed.1be8cb9.jpg";